import React from 'react';
import App from './App';
import MobileApp from './MobileApp';

const AppRouter = () => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  return isMobile ? <MobileApp /> : <App />;
};

export default AppRouter; 